export default "__VITE_ASSET__3e281c36__"